import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoButtonDirective } from './avano-button.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoButtonDirective],
  declarations: [AvanoButtonDirective]
})
export class AvanoButtonModule {}
